import { render, staticRenderFns } from "./IbSup.vue?vue&type=template&id=90adc4a2&scoped=true"
import script from "./IbSup.vue?vue&type=script&lang=js"
export * from "./IbSup.vue?vue&type=script&lang=js"
import style0 from "./IbSup.vue?vue&type=style&index=0&id=90adc4a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90adc4a2",
  null
  
)

export default component.exports